import { KeyboardOutlined } from '@mui/icons-material'
import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { font } from '../../styles/font'

export default function ShortcutText({ keyboardShortcutText, textColor }) {
    const theme = useTheme();

    return (
        <Box className="flex items-center gap-0.5 px-1 py-0.5 " bgcolor={theme.palette.background.custom} borderRadius={theme.shape.borderRadius} sx={{ color: textColor ? textColor : "textSecondary" }}>
            <KeyboardOutlined sx={{ color: "inherit" }} />
            <Typography fontSize={font.size.fs_5} color="inherit">{keyboardShortcutText}</Typography>
        </Box>
    )
}
